export default {
    homePage: {
        Todolist: '待办事项',
        New: '新订单',
        Processing: '处理中订单',
        Error: '异常订单',
        InProcess: '待处理退货订单',
        Draft: '草稿',
        ApprovalPending: '待审批工单',
        AwaitingProcessing: '待处理工单',
        InProgress: '处理中工单',
        ApprovalRejected: '审批不通过工单',
        QuickAccess: '快捷入口',
        AddInbound: '新建入库',
        AddProduct: '新建商品',
        Inventory: '查询库存',
        AddOutbound: '新建出库',
        AddReturn: '新建售后',
        AddTicket: '新建工单',
        KeyData: '关键数据',
        Date: '日期',
        Yesterday: '昨天',
        Last7Days: '最近7天',
        Last30Days: '最近30天',
        TotalOutbound: '总出库单',
        ShippedOutbound: '已完成出库单',
        TotalInbound: '总入库单',
        ShippedInbound: '已完成入库单',
        TotalReturn: '总退货单',
        BasicStatistic: '基础统计',
        OrdersShipped: '已发货订单量',
        AvailableSKU: '可用SKU',
        AvailableInventory: '当前可用库存',
        AuthorizedStore: '授权店铺',
        ProcessedReturn: '已处理退货',
        OutboundOrder: '出库单通知',
        SalesManager: '销售经理',
        CustomerService: '客服代表',
        TotalCustomers: '客户总数',
        Inbound: '入库订单',
        Product: '查看商品',
        Outbound: '出库订单',
    },
    systemOnlineNtf: {
        title: '标题',
        version: '版本号',
        notifyDate: '发布日期',
        notifyStatus: '通知状态',
        loginName: '创建人',
        readNumber: '阅读人数',
        newAddFe: '新增功能',
        feList: '功能点列表',
        filesList: '附件列表',
        checkReadText: '我已阅读并了解系统更新内容',
        checkAndClose: '确认并关闭',
        description: '概述',
        featureName: '名称',
        featureDescription: '描述',
        preViewNtf: '预览通知',
        featureImg: '功能截图',
        opManual: '操作手册',
        upLineConfirm: '确定要上线？',
        downLineConfirm: '确定要下线？',
        draftConfirm: '确定保存为草稿？',
        publishConfirm: '确定发布？',
        moreVersion: '查看以往系统版本更新内容',
        ntfMenu: '系统上线通知',
        ntfDialogTitle: '系统上线通知'
      }
}